import {PlainReduxAction} from './redux-action';

export const RESET = 'RESET';
export type ResetAction = PlainReduxAction<typeof RESET>;



// WEBPACK FOOTER //
// ./src/actions/reset.ts